"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _priceSetting = require("@/api/priceSetting");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _useProduct2 = require("@/hooks/use-product");
var _vuex = require("vuex");
var _product = _interopRequireDefault(require("@/mixins/product"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _useProduct = (0, _useProduct2.useProduct)(),
  productTypeList = _useProduct.productTypeList;
var _default2 = exports.default = {
  // name: "index"
  components: {
    merchantName: _merchantName.default
  },
  props: {
    initGoodsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['merPlatProductClassify'])), (0, _vuex.mapGetters)(['productBrand'])),
  mixins: [_product.default],
  data: function data() {
    return {
      constants: this.$constants,
      productTypeList: productTypeList,
      listData: {
        list: [],
        total: 0
      },
      listPram: {
        keywords: undefined,
        categoryId: undefined,
        brandId: undefined,
        merId: undefined,
        isPaidMember: undefined,
        productId: undefined,
        minPrice: undefined,
        maxPrice: undefined,
        minStock: undefined,
        maxStock: undefined,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      selectedGoods: []
    };
  },
  mounted: function mounted() {
    console.log('this.initGoodsList', this.initGoodsList);
    this.selectedGoods = this.initGoodsList;
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('productBrand')) this.$store.dispatch('product/getMerProductBrand');
    console.log('this.merPlatProductClassify', this.merPlatProductClassify);
    console.log('this.productBrand', this.productBrand);
    this.getGoodsList();
  },
  watch: {
    initGoodsList: function initGoodsList(val) {
      var _this = this;
      if (val) {
        this.selectedGoods = val;
        this.$nextTick(function () {
          _this.$refs.multipleTable.clearSelection();
        });
        var tempSelectedGoods = [];
        this.listData.list.forEach(function (item) {
          var flag = _this.selectedGoods.some(function (selectedItem) {
            return selectedItem.specId === item.specId;
          });
          if (flag) {
            tempSelectedGoods.push(item);
          }
          console.log(tempSelectedGoods);
        });
        this.toggleSelection(tempSelectedGoods);
      }
    }
  },
  methods: {
    formatMoney: function formatMoney(value) {
      var num = Number(value);
      if (!Number.isFinite(num)) return '0.00';
      return num.toFixed(2);
    },
    close: function close() {
      this.$emit('hideGoodsDialog');
    },
    getMerId: function getMerId(id) {
      this.listPram.merId = id;
      this.getGoodsList();
    },
    getGoodsList: function getGoodsList() {
      var _this2 = this;
      (0, _priceSetting.getPriceList)(this.listPram).then(function (data) {
        _this2.listData = data;
        if (data && data.list.length > 0) {
          var tempSelectedGoods = [];
          data.list.forEach(function (item) {
            var flag = _this2.selectedGoods.some(function (selectedItem) {
              return selectedItem.specId === item.specId;
            });
            if (flag) {
              tempSelectedGoods.push(item);
            }
            console.log(tempSelectedGoods);
          });
          _this2.toggleSelection(tempSelectedGoods);
        }
      });
    },
    reset: function reset() {
      this.listPram = {
        keywords: '',
        categoryId: [],
        isSelf: undefined,
        merId: undefined,
        isPaidMember: undefined,
        productType: undefined,
        page: 1,
        limit: this.$constants.page.limit[0]
      };
      this.getGoodsList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.getGoodsList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.getGoodsList();
    },
    handleSeachList: function handleSeachList() {
      this.listPram.page = 1;
      this.getGoodsList();
    },
    handleSelectionChange: function handleSelectionChange(val, row) {
      console.log(val, row);
      var tempSelectedGoods = _toConsumableArray(this.selectedGoods);
      // this.handleSelect(val)
      var flag = val.some(function (selectedItem) {
        return selectedItem.specId === row.specId;
      });
      if (flag) {
        tempSelectedGoods.push(row);
      } else {
        var index = tempSelectedGoods.findIndex(function (selectedItem) {
          return selectedItem.specId === row.specId;
        });
        tempSelectedGoods.splice(index, 1);
      }
      this.selectedGoods = tempSelectedGoods;
    },
    handleSelectionAllChange: function handleSelectionAllChange(val) {
      console.log(val);
      this.handleSelect(val);
    },
    toggleSelection: function toggleSelection(rows) {
      var _this3 = this;
      if (rows) {
        rows.forEach(function (row) {
          console.log(row);
          _this3.$nextTick(function () {
            _this3.$refs.multipleTable.toggleRowSelection(row, true);
          });
        });
      }
    },
    handleSelect: function handleSelect(selection) {
      var tempSelectedGoods = _toConsumableArray(this.selectedGoods);
      if (selection.length === 0) {
        this.listData.list.forEach(function (item) {
          var flag = tempSelectedGoods.some(function (selectedItem) {
            return selectedItem.specId === item.specId;
          });
          if (flag) {
            var index = tempSelectedGoods.findIndex(function (selectedItem) {
              return selectedItem.specId === item.specId;
            });
            tempSelectedGoods.splice(index, 1);
          }
        });
      } else {
        selection.forEach(function (row) {
          var selected = tempSelectedGoods.some(function (item) {
            return item.specId === row.specId;
          });
          if (!selected) {
            tempSelectedGoods.push(row);
          }
        });
      }
      this.selectedGoods = tempSelectedGoods;
    },
    handlerSubmit: function handlerSubmit() {
      this.$emit('submitGoodsList', this.selectedGoods);
    }
  }
};